import { gql } from '@apollo/client'
import { AUDIT_INVENTORY_ITEM_FRAGMENT } from './AuditInventoryItemFragment'

export const DISPLAY_AUDIT_FRAGMENT = gql`
  fragment DisplayAudit on DisplayAudit {
    __typename
    id
    products {
      ...AuditInventoryItem
    }
    dateCompleted
    display {
      id
      isCompetitor
      area
      displayType
    }
    images {
      id
      url
    }
  }
  ${AUDIT_INVENTORY_ITEM_FRAGMENT}
`
